module.exports = __webpack_public_path__ + "images/newerp_webicon.1790221230673.png";